import React from 'react'
import { gql } from '@apollo/client'
import ShowcaseGridView from '../ShowcaseGridView'

export const MUSEUM_OWNED_ART_SEARCH = gql`
	query searchDynamicArt($field: String, $direction: SortDirection, $cursor: Int, $filters: [SearchFilter], $limit: Int) {
		searchDynamicArt(input: { field: $field, direction: $direction, limit: $limit, cursor: $cursor, filters: $filters }) {
			cursor
			totalItems
			items {
				id
				title
				artist {
					id
					first_name
					last_name
				}
				code_name
				imgUrl
				year
				status {
					id
					value
				}
				primary_currency_id
				primaryRetailPrice
				current_sources {
					id
					code_name
					first_name
					last_name
					is_company
					company_name
					is_deleted
					is_private
					imgUrl (thumbnailResolution: "128x128")
					canNavigate
					isAllowedContactType
					dynamic_generated_codename
					created_at
					deal_entry_status_category
					deal_entry_status
					contact_role_id
				}

				medium
				all_dimensions
			}
		}
	}
`

export const MuseumOwned = (props: any) => {

	const filters =  [
		{ field: 'artist_id', type: 'eq', value: props.id, isOptional: false },
		{
			field: "source_type.current_sources",
			isOptional: false,
			nestedQueryType: "Source",
			type: "contains",
			value: "Museum"
		},
	]

	return (
		<ShowcaseGridView
			filters={filters}
			query={MUSEUM_OWNED_ART_SEARCH}
			showReserve={true}
			state={props.state}
			page="MuseumOwned"
			showcaseInformation={props.showcaseInformation}
			setShowcaseInformation={props.setShowcaseInformation}

			showcaseSelectMode={props.showcaseSelectMode}
			setShowcaseSelectMode={props.setShowcaseSelectMode}
		/>
	)
}

export default MuseumOwned
